// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDAboGytOmmkDNQSZ2YLUvXLZPr4gKlEuo",
  authDomain: "managecantine.firebaseapp.com",
  projectId: "managecantine",
  storageBucket: "managecantine.appspot.com",
  messagingSenderId: "638779525673",
  appId: "1:638779525673:web:5651324d2e3d6b511f2a38",
  measurementId: "G-BHX0JYHB4J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // La persistance a été définie avec succès.
    console.log('Persistance de l\'authentification configurée pour LOCAL.');
  })
  .catch((error) => {
    // Gérer les erreurs
    console.error('Erreur lors de la configuration de la persistance :', error);
  });

export { auth, db, analytics };